/* DillySocks — Trusted-Shops-Wertung in der Trust-Pille (Sean 16.09.2026).

   Die Pille steht bereits serverseitig mit Startwerten aus den Theme-
   Einstellungen. Dieses Script tauscht die Zahlen im Hintergrund gegen den
   aktuellen Wert der oeffentlichen Trusted-Shops-API aus (Gesamtnote +
   Anzahl Bewertungen). Kein Warten auf das Trusted-Shops-Widget mehr —
   frueher wurde dessen DOM bis zu 10 s lang abgefragt, und bis dahin
   fehlte die Wertung in der Pille.

   Cache: localStorage, 6 Stunden — eine Anfrage pro Besucher:in und
   Zeitraum statt pro Seitenaufruf. Bei Fehlern bleiben die Startwerte. */
(() => {
  const CACHE_KEY = 'ds_ts_rating_v1';
  const CACHE_TTL_MS = 6 * 60 * 60 * 1000;

  function readCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const c = JSON.parse(raw);
      if (!c || typeof c.mark !== 'number' || Date.now() - (c.at || 0) > CACHE_TTL_MS) return null;
      return c;
    } catch (e) { return null; }
  }
  function writeCache(mark, count) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ mark: mark, count: count, at: Date.now() })); } catch (e) {}
  }

  function apply(roots, mark, count) {
    roots.forEach((root) => {
      const starsEl = root.querySelector('[data-ds-ts-rating-stars]');
      const textEl = root.querySelector('[data-ds-ts-rating-text]');
      const dec = root.dataset.dsTsDecimal || ',';
      const label = root.dataset.dsTsLabel || '';
      const pct = Math.max(0, Math.min(100, (mark / 5) * 100));
      if (starsEl) starsEl.style.setProperty('--ds-rating-pct', pct.toFixed(1) + '%');
      if (textEl) textEl.textContent = mark.toFixed(2).replace('.', dec) + (count ? ' (' + count + ')' : '') + (label ? ' ' + label : '');
    });
  }

  function fetchRating(tsId, roots) {
    fetch('https://api.trustedshops.com/rest/public/v2/shops/' + encodeURIComponent(tsId) + '/quality/reviews.json')
      .then((res) => (res.ok ? res.json() : null))
      .then((json) => {
        const ind = json && json.response && json.response.data && json.response.data.shop &&
          json.response.data.shop.qualityIndicators && json.response.data.shop.qualityIndicators.reviewIndicator;
        if (!ind || typeof ind.overallMark !== 'number') return;
        const count = ind.totalReviewCount || 0;
        writeCache(ind.overallMark, count);
        apply(roots, ind.overallMark, count);
      })
      .catch(() => {});
  }

  function start() {
    const roots = Array.from(document.querySelectorAll('[data-ds-ts-rating]'));
    if (!roots.length) return;
    const cached = readCache();
    if (cached) { apply(roots, cached.mark, cached.count); return; }
    const tsId = roots[0].dataset.dsTsId;
    if (!tsId) return;
    const run = () => fetchRating(tsId, roots);
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 3000 }); else setTimeout(run, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
